<template>
  <div :class="$style.container">
    <header>
      <span>提示</span>
      <i :class="[$style.fanhui, 'iconfont', 'yw-guanbi1']" @click="$emit('close')"></i>
    </header>
    <main>
      <p>由于功能限制</p>
      <p>请前往<span>玩心手游app</span>内享受云挂机服务</p>
      <button @click="submit">点击前往</button>
      <p :class="$style.redirect" v-if="cloud_hang_up_box_url">APP内更可享受95折购买优惠</p>
    </main>
    <BoxDownload v-if="boxDownLoadShow" @close="boxDownLoadShow = false" type="wx"></BoxDownload>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { sendSyDiyIntent, gameOpenDownloads } from '@/bridge/AppJsBridge';
import { generActLink } from '@/libs/business/box';
import { wxBoxDownloadUrl } from '@/config';
import BoxDownload from '@/components/Suspend/common/boxDownload.vue';
import { buryReportV2 } from '@/libs/business/account';
import { redirBoxNewVersion } from '@/libs/business/version'

export default {
  data() {
    return {
      deviceName: '',
      boxDownLoadShow: false,
    };
  },
  props: ['currentDevice'],
  mounted() {
    this.deviceName = this.currentDevice.custom_name;
  },
  computed: {
    ...mapState({
      cloud_hang_up_box_url: (state) => state.suspend.cloud_hang_up_box_url,
      cloud_hang_up_template_id: (state) => state.suspend.cloud_hang_up_template_id,
      cloud_hang_up_template_name: (state) => state.suspend.cloud_hang_up_template_name,
    }),
  },
  methods: {
    async submit() {
      const appkey = this.$getStorage('appkey');
      const gameUrl = await generActLink(this.cloud_hang_up_box_url);
      if (redirBoxNewVersion()) {
        sendSyDiyIntent({
          appKey: appkey,
          boxConfig: {
            boxDownloadUrl: wxBoxDownloadUrl(),
            boxName: '玩心手游',
            packageName: 'com.hzwx.wx.box',
          },
          url: gameUrl,
        });
      } else {
        gameOpenDownloads({
          gameUrl: gameUrl,
        });
        this.boxDownLoadShow = true;
      }
      buryReportV2('CLOUD_HANG_UP_GO_TO_CLICK_OLD', {
        cloud_hang_up_template_id: this.cloud_hang_up_template_id,
        cloud_hang_up_template_name: this.cloud_hang_up_template_name,
        cloud_hang_up_box_url: gameUrl,
      });
    },
  },
  components: {
    BoxDownload,
  },
};
</script>
<style module lang="scss">
.container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 260px;
  height: 160px;
  background: #ffffff;
  border-radius: 5px;
  > header {
    color: #ffffff;
    width: 260px;
    height: 30px;
    background: #ff5b58;
    border-radius: 5px 5px 0px 0px;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    .fanhui {
      position: absolute;
      right: 10px;
      font-size: 14px;
    }
  }
  > main {
    padding-top: 15px;
    > p {
      font-size: 14px;
      line-height: 22px;
      text-align: center;
      > span {
        color: #ff5b58;
      }
    }
    > button {
      display: block;
      border: none;
      outline: none;
      padding: 5px 18px;
      background: #ff5b58;
      border-radius: 14px;
      font-size: 12px;
      text-align: center;
      color: #ffffff;
      margin: auto {
        top: 5px;
      }
      &:active {
        opacity: 0.7;
      }
    }
    .redirect {
      color: #ff5b58;
      font-size: 10px;
      position: absolute;
      bottom: 0;
      right: 5px;
    }
  }
}
</style>
